/**
 * @desc: - 面板- 投注页近期开奖
 * @param  {[STRING]} className      [顶层样式类]
 * @param  {[ARRAY]}  history        [开奖号码组] [{issue: '20170803-0654', code:'1123'}]
 * PK10等，开奖号码超过5位的需要显示详情按钮
 * @author: klaf
 */
import React from 'react';
import { bindActionCreators } from 'redux'
import ReactDOM from 'react-dom'
import Loader from '../../../components/icon/Loader.jsx'
// import HistoryLhc from '../../../containers/pc-day/lotterys/LhcSelectArea.jsx'
import { importDatePrototype } from '../../../helpers/unit.js';
import { DOMAIN } from '../../../constants/config';

export default class RecentlyCodes extends React.Component {

  constructor(props) {
    super(props);
    this.showDetail = this.showDetail.bind(this);
    this.makeCodeDetail = this.makeCodeDetail.bind(this);
    this.hideDetail = this.hideDetail.bind(this);
    this.state = {
      currentNums: [],//弹窗中的数字
      showDetail:false,
      index:''
    }

    importDatePrototype();//日期格式化拓展
  }

  componentDidMount() {
    // 点击任意处关闭弹窗
    document.onclick = function (event) {
      if (event.target.className.indexOf('more') > -1) {
        return;
      }
      this.hideDetail()
    }.bind(this)
  }

  componentWillUnmount() {
    document.onclick = null;
  }

  // 显示详细弹窗
  showDetail(index, row) {
    this.setState({
      currentNums:row.split_code,
      showDetail:true,
      index:index
    })
  }

  hideDetail(){
    this.setState({
      showDetail:false
    })
  }
  // 生成最近投注详情
  makeCodeDetail() {
    const { flag, history, tmpl, current } = this.props;
    const showFlag = ['pk10','ydl10']
    const jssmFlag = ['jssm']
    // 六合彩
    if (flag === 'xglhc') {
      let issue = 'xxxx-xxx';
      let ymd = 'xxxx-xx-xx';
      let week = 'xxx'
      let time = '--:--:--';
      if (current && current.current) {
        issue = current.current.issue;
        ymd = (new Date(current.current.saleend.replace(/-/g, '\/') + ' GMT+0800')).pattern("YYYY-MM-DD");// YYYY-MM-DD EEE hh:mm:ss
        week = (new Date(current.current.saleend.replace(/-/g, '\/') + ' GMT+0800')).pattern("EE");
        time = (new Date(current.current.saleend.replace(/-/g, '\/') + ' GMT+0800')).pattern("HH:mm:ss");
      }
      return <ul className='lhc-list clear'>
          {/*<li className="lhc">*/}
              {/*当前期数：<span>第 </span>*/}
              {/*<span className="current_issue">{issue}</span><span> 期</span>*/}
          {/*</li>*/}
          <li className="fl">
              截止日期：<span id="current_enddate">{ymd ? ymd : ''}</span>&nbsp;
              <span id="current_endweek">{week ? week : ''}</span>
          </li>
          <li className="fr">
              时间：<span id="current_endtime">{time ? time : ''}</span>
          </li>
          {/*<li className="lhc"></li>*/}
          {/*<li className="lhc">*/}
              {/*<a href="#/report/help/playinfo" target="_blank">玩法介绍</a>*/}
          {/*</li>*/}
        </ul>
    }
    // 秒秒彩
    if (flag === 'mmc') {
      return <ul className='mmc_recent-award'>
        {
          history && history.length > 0 ? history.map((row, index) => {
            return <li key={index} className={index == 0 ? 'hover' : ''}>
              {row.code}
            </li>
          }) : null
        }
      </ul>
    }


    // 其他彩种
    return history && history.length > 0 ? history.map((row, index) => {
      return <li key={index} className={index == 0 ? 'hover' : ''}>
        <span className={row.code.length > 14 ? 'issue_k8' : 'issue'}>{row.code.length > 14 && row.issue.length > 18 ? row.issue.substring(4) : row.issue} 期</span>
        <span className={row.code.length > 14 ? 'num_k8' : 'num'}>{_.join(row.split_code, ' ')}
          <span className="more" onClick={this.showDetail.bind(this, index, row)}>{row.code.length > 14 ? '详细' : ''}</span>
        </span>
        <div className="seeMore ab" style = {{display:index==this.state.index&&this.state.showDetail?"block":"none"}} title="点击关闭详情" id="panel-recent-detail">
          {
            this.state.currentNums.map((row, index) => {
              if(_.includes(showFlag,flag)){
                return <span className={"trank car" + row} key={index}>{row}</span>
              }
              if(_.includes(jssmFlag,flag)){
                return <span className={"trank horse" + row} key={index}>{row}</span>
              }
              return <span key={index}>{row || '-'}</span>
            })
          }

        </div>
      </li>
    }) : null
  }
  render() {
    const { className, history, tmpl, current,flag,lotteryId, windowId, __methods } = this.props;

    return (
      <div className="panel-recentlybox" onMouseLeave={this.hideDetail}>
          {
              flag === 'xglhc' ?
                  <div>
                      {
                          this.makeCodeDetail()
                      }
                      <div className="recentBox">
                          <h3>
                              <span>{(tmpl == 'lhc' ? '本' : '近') + '期开奖'}</span>
                          </h3>
                          <div className="overflow-auto">
                              <div className={tmpl == 'lhc' ? 'recentCon re lhcheight' : 'recentCon re'}
                                   style={{'zIndex': (this.state.more ? '100' : '1')}}>
                                  {
                                      !history ? <Loader/> : <HistoryLhc windowId={windowId} __methods={__methods}/>
                                  }
                              </div>
                          </div>

                      </div>
                  </div>
                  :
                  <div className="recentBox">
                      <h3>
                          <span>{(tmpl == 'lhc' ? '本' : '近') + '期开奖'}</span>
                      </h3>
                      <div className="overflow-auto">
                          <div className={tmpl == 'lhc' ? 'recentCon re lhcheight' : 'recentCon re'}
                               style={{'zIndex': (this.state.more ? '100' : '1')}}>
                              {
                                  !history ? <Loader/> : null
                              }
                          </div>
                          <ul>
                              {
                                  this.makeCodeDetail()
                              }
                          </ul>
                      </div>
                  </div>
          }
      </div>
    );
  }
}

// 开奖结果
class HistoryLhc extends React.Component {

    constructor(props) {
        super(props);
        this.getNumberColor = this.getNumberColor.bind(this);
        this.openCode = this.openCode.bind(this);
        // 六合彩红蓝绿色对照表
        this.colorDic = {
            bc_red: [1, 2, 7, 8, 12, 13, 18, 19, 23, 24, 29, 30, 34, 35, 40, 45, 46],
            bc_blue: [3, 4, 9, 10, 14, 15, 20, 25, 26, 31, 36, 37, 41, 42, 47, 48],
            bc_green: [5, 6, 11, 16, 17, 21, 22, 27, 28, 32, 33, 38, 39, 43, 44, 49]
        }


    }
    getNumberColor(num) {
        // 06 -> 6
        num = parseInt(num);
        var temp;
        // 红波
        temp = this.colorDic['bc_red'];
        if (temp.indexOf(num) > -1) {
            return 'red';
        }
        // 蓝波
        temp = this.colorDic['bc_blue'];
        if (temp.indexOf(num) > -1) {
            return 'blue';
        }
        // 绿波
        temp = this.colorDic['bc_green'];
        if (temp.indexOf(num) > -1) {
            return 'green';
        }
        // 默认连接线
        return 'and';
    }
    openCode(){
        const {__methods,windowId } = this.props;
        const history = __methods.windows[windowId].history_issue;
        if (history) {
            _.forEach(history, function (item) {
                let temp = item.split_code;
                let temp2 = _.chunk(temp, 2);
                let arr = [];
                _.forEach(temp2, function (it, k) {
                    let tmp = it.join('');
                    arr.push(tmp);
                    if (k == 5) {//第五个数字后面加个连接线
                        arr.push(' ');
                    }
                })
                item.newArr = arr;
            })
            return history.map((row, index) => {
                let drawTime = /\d{4}-\d{1,2}-\d{1,2}/g.exec(row.draw_time)
                return <ul key={index}>
                    <li className="s-1">{row.issue}期</li>
                    {/*<li className="s-2">{drawTime}</li>*/}
                    <li className="s-3">
                        {
                            row.newArr.map((r, i) => {
                                return <span key={i} className={this.getNumberColor(r)}>{r}</span>
                            })
                        }
                    </li>
                </ul>
            })
        }
    }

    render() {
        return (
            <div className="lotteryView_lhc">
                <div className="lhcBox">
                    {/*<ul className="title">*/}
                        {/*<li className="s-1">期号</li>*/}
                        {/*<li className="s-2">开奖日期</li>*/}
                        {/*<li className="s-3">开奖号码</li>*/}
                    {/*</ul>*/}
                    {
                        this.openCode()
                    }
                </div>
            </div>
        );
    }
}